module.exports = __webpack_public_path__ + "static/img/ckmzjg_jcjg_icon.png";